export default __webpack_public_path__ + "static/media/license-img.83a156f1.jpeg";